import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { Button, Form, Row, Field, RelationSelect } from '@smartplatform/ui';
import { Editor } from '../../components';
import store from '../../store';

@observer
export default class Edit extends React.Component {

    @observable record = null;
    @observable error = null;
    @observable htmlMode = true;

    constructor(props) {
        super(props);
        this.init();
    }

    init = async () => {
        this.id = this.props.match.params.id;
        this.error = null;
        if (this.id) {
            try {
                this.record = await store.model.Governance.findById(this.id);
            }
            catch(e) {
                this.error = e.message;
            }
        }
        else {
            this.record = new store.model.Governance();
        }
    };

    switchMode = () => this.htmlMode = !this.htmlMode;
	
    fio = record => <>
		{record.lastName} {record.firstName} {record.middleName}
	</>;
	
    render() {
        if (!this.record && !this.error) return '...';
        if (this.error) return this.error;

        return <>
            <p>Страница</p>
            <Form record={this.record} rootPath="/admin" returnTo="/admin/governance">
                <Field property="name" label="ФИО" />
	            <Field relation="deputy" label="Депутат" computed={this.fio}>
		            <RelationSelect searchFields={[{ name: 'lastName', start: true }]} />
	            </Field>
	            <Field property="contacts" label="Контакты">
		            <Editor height={300}/>
	            </Field>
                <Field property="text" label="Текст">
	                <Editor
		                mediaModel={store.model.Image}
		                acceptFiles={['image/jpeg', 'image/png']}
		                mediaProperty="filename"
		                height={500}
	                />
                </Field>
            </Form>
        </>;
    }

}
